/**
 * Hub (staff chat) schemas — message attachments and voice notes.
 *
 * Attachments are stored as files under UPLOAD_DIR/hub with random names;
 * `path` is just the stored filename, served only via the authenticated
 * GET /v1/hub/attachments/:file endpoint (never the public /v1/uploads static).
 */

import { z } from 'zod';

export const hubAttachmentKindSchema = z.enum(['file', 'image', 'audio']);
export type HubAttachmentKind = z.infer<typeof hubAttachmentKindSchema>;

export const hubAttachmentSchema = z.object({
  /** Original filename as uploaded. */
  name: z.string().min(1).max(255),
  /** Bytes. */
  size: z.number().int().min(0).max(200 * 1024 * 1024),
  mime: z.string().min(1).max(100),
  /** Stored filename (uuid + ext) under uploads/hub — never a user-supplied path. */
  path: z.string().regex(/^[0-9a-f-]{36}(\.[a-z0-9]{1,10})?$/),
  kind: hubAttachmentKindSchema,
  /** Voice notes: recording length in seconds. */
  durationSec: z.number().min(0).max(300).optional(),
});
export type HubAttachment = z.infer<typeof hubAttachmentSchema>;
